export default __webpack_public_path__ + "static/media/sort-vertical-2.10ba8575.svg";